const menu      = require('../../../../../components/menu/menu')
const dtHandler = require('../../../../../components/dt/dt-handler')

export function start(detail, htmlDt) {
  const options = menuBody[detail.id]
  options.forEach((option) => option.start(detail, htmlDt))
  detail.html = options
  detail.act = 'show'
  menu.start(detail)
}

const deleteOption = {
  text: '',
  svg: 'delete',
  class: '',
  dataDetail: '',
  start: function(detail, htmlDt) {
    const ids = detail.id === 'trMenu' ? [String(detail.dbid)] : dtHandler.getTrChecked(htmlDt)
    this.text = ids.length ? `Delete (${ids.length})` : 'Delete'
    this.class = ids.length ? '' : 'disabled'
    this.dataDetail = ids.length ? `data-detail='{"click":[{"dest":"ripple"},{"dest":"menu","act":"hide"},
      {"dest":"accountreconciliation","elem":"fullcont","act":"deleteEntity","entity":"accountreconciliation","dbid":${JSON.stringify(ids)}}]}'` : ''
  },
}

const menuBody = {
  tableOptions: [deleteOption],
  trMenu: [
    {
      text: 'View/Edit',
      svg: 'eye',
      class: '',
      dataDetail: '',
      start: function(detail) {
        this.dataDetail = `data-detail='{"click":[{"dest":"ripple"},{"dest":"menu","act":"hide"},
          {"dest":"accountreconciliation","elem":"fullcont","id":"accountreconciliation-fullcont","act":"selectOne","entity":"accountreconciliation","dbid":"${detail.dbid}"}]}'`
      },
    },
    deleteOption,
  ],
}
